import React, { FC } from 'react'
import styles from 'styles/components/image.module.scss'

const RedLogo: FC = () => {
  return (
    <div className={styles.logo__red}>
      <img src={'/logo/red.svg'} alt={'sacri for Owners'} />
    </div>
  )
}

export default RedLogo
